export default __webpack_public_path__ + "static/media/mini-anima-logo.86da400d.svg";